import { NzTableFilterFn, NzTableFilterList, NzTableSortFn, NzTableSortOrder } from 'ng-zorro-antd/table';
import { OrgType } from '../../../API';

export enum AccountStatus {
  True = 'ENABLED',
  FALSE = 'DISABLED',
}

export interface TableColumnItem {
  name: string;
  key?: string;
  sortOrder: NzTableSortOrder | null;
  sortFn?: NzTableSortFn<DisplayFlattenUser> | null | any;
  listOfFilter?: NzTableFilterList | null | any;
  filterFn?: NzTableFilterFn<DisplayFlattenUser> | null | any;
  filterMultiple?: boolean;
  sortDirections: NzTableSortOrder[];
  width?: string;
  left?: boolean;
  right?: boolean;
}

export interface DisplayFlattenUser {
  name?: string | null;
  email?: string | null;
  organization?: string | null;
  orgType?: string | null;
  role?: string | null;
  status?: string | null;
  createdAt?: string | null;
  updatedAt?: number | null;
  lastActivity?: string | null;
  sub?: string | null;
}

export const HEADERS: TableColumnItem[] = [
  {
    name: 'Name',
    key: 'name',
    sortOrder: null,
    sortFn: (a: DisplayFlattenUser, b: DisplayFlattenUser) => a.name?.localeCompare(b.name ?? ''),
    sortDirections: ['ascend', 'descend', null],
    filterMultiple: true,
    listOfFilter: [],
    filterFn: null,
    width: '8rem',
  },
  {
    name: 'Email',
    key: 'email',
    sortOrder: null,
    sortFn: (a: DisplayFlattenUser, b: DisplayFlattenUser) => a.email!.localeCompare(b.email!),
    sortDirections: ['ascend', 'descend', null],
    width: '12rem',
  },
  {
    name: 'Organization',
    key: 'organization',
    sortOrder: null,
    sortDirections: ['ascend', 'descend', null],
    sortFn: (a: DisplayFlattenUser, b: DisplayFlattenUser) => a.organization?.localeCompare(b.organization ?? ''),
    filterMultiple: false,
    listOfFilter: [],
    filterFn: (orgType: string, item: DisplayFlattenUser) =>
      item.organization && item.organization?.indexOf(orgType) !== -1,
    width: '8rem',
  },
  {
    name: 'Role',
    key: 'role',
    sortOrder: null,
    sortDirections: ['ascend', 'descend', null],
    sortFn: (a: DisplayFlattenUser, b: DisplayFlattenUser) => a.role?.localeCompare(b.role ?? ''),
    filterMultiple: true,
    listOfFilter: [],
    filterFn: (role: string, item: DisplayFlattenUser) => item.role && item.role.indexOf(role) !== -1,
  },
  {
    name: 'Status',
    key: 'status',
    sortOrder: null,
    sortDirections: ['ascend', 'descend', null],
    sortFn: (a: DisplayFlattenUser, b: DisplayFlattenUser) => a.status!.localeCompare(b.status!),
    filterMultiple: false,
    listOfFilter: [
      {
        text: 'ENABLED',
        value: AccountStatus.True,
      },
      {
        text: 'DISABLED',
        value: AccountStatus.FALSE,
      },
    ],
    filterFn: (status: string, item: DisplayFlattenUser) => item.status === status,
    width: '8rem',
  },
  {
    name: 'Created Date',
    key: 'createdAt',
    sortOrder: null,
    sortDirections: ['ascend', 'descend', null],
    sortFn: (a: DisplayFlattenUser, b: DisplayFlattenUser) => a.createdAt!.localeCompare(b.createdAt!),
    width: '12rem',
  },
  {
    name: 'Updated Date',
    key: 'updatedAt',
    sortOrder: 'descend',
    sortDirections: ['ascend', 'descend', null],
    sortFn: (a: DisplayFlattenUser, b: DisplayFlattenUser) => (a.updatedAt ?? 0) - (b.updatedAt ?? 0),
    width: '12rem',
  },
  {
    name: 'Last Activity',
    key: 'lastActivity',
    sortOrder: null,
    sortDirections: ['ascend', 'descend', null],
    sortFn: (a: DisplayFlattenUser, b: DisplayFlattenUser) => a.lastActivity!.localeCompare(b.lastActivity!),
    width: '12rem',
  },
];

export interface CreateUserForm {
  firstName: string;
  lastName: string;
  email: string;
  orgName: string;
  orgType: string;
  role: string;
  userWillExportViaSFTP?: boolean;
  bucketName?: string;
}

export interface SelectOption {
  name: string;
  value: string;
}

export const orgTypeOptions = [
  {
    name: 'League',
    value: OrgType.LEAGUE,
  },
  {
    name: 'Club',
    value: OrgType.CLUB,
  },
  {
    name: 'Sponsor',
    value: OrgType.SPONSOR,
  },
];
